'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import { bloomreachPixelSendOtherView } from '../../../../../../modules/analytics/bloomreach/BloomreachPixel/sendBloomreachPageViewTrackingEvent';
import { checkBrEnv } from '../../../../../../modules/analytics/bloomreach/BloomreachPixel/helpers/checkBrEnv';

/**
 * Bloomreach tracking pixel for generic pages.
 */
const GenericPageBloomreachPixel = () => {
    const pathName = usePathname();

    // Path name is a dependency because the user may jump from one generic page to another generic page and
    // we'll need this to run if that happens.
    useEffect(() => {
        // If bloomreach is not enabled then we don't want to do anything.
        if (checkBrEnv() === false) {
            return;
        }

        bloomreachPixelSendOtherView();
    }, [pathName]);

    return null;
};

export default GenericPageBloomreachPixel;
